import {createAction, props} from '@ngrx/store';
import {IStore} from '../../../shared/shared-models/store/store';
import {INotification} from '../../../shared-utilities/models-old/datastructures';
import {IDataTimeStamps, IFromAppQueueItem} from '../models';
import {IGlobalError} from '../../../shared/shared-components/components/global-error-display/models/global-error';

// ====================================================================================================
// Get Image URL
// ====================================================================================================
export const getImageURL = createAction(
  '[Core][Image] Get Image URL',
  props<{path: string, image: string}>(),
);

export const getImageURLSuccess = createAction(
  '[Core][Image] Get Image URL Success',
  props<{url: string, image: string}>(),
);

export const getImageURLFailure = createAction(
  '[Core][Image] Get Image URL Failure',
  props<{error: IGlobalError, image: string}>(),
);

// ====================================================================================================
// User Messages
// ====================================================================================================
export const getUserMessages = createAction(
  '[Core][Messages] Get User Messages',
);

export const getUserMessagesSuccess = createAction(
  '[Core][Messages] Get User Messages Success',
  props<{messages: INotification[]}>(),
);

export const getUserMessagesFailure = createAction(
  '[Core][Messages] Get User Messages Failure',
  props<{error: IGlobalError}>(),
);

export const setIsUserMessageCountLoading = createAction(
  '[Core][Messages] Set Is User Message Count Loading',
  props<{isLoading: boolean}>(),
);

export const getFromAppQueue = createAction(
  '[Core][Messages] Get From App Queue',
  props<{storeIds?: string[]}>(),
);

export const getFromAppQueueSuccess = createAction(
  '[Core][Messages] Get From App Queue Success',
  props<{items: IFromAppQueueItem[]}>(),
);

export const getFromAppQueueFailure = createAction(
  '[Core][Messages] Get From App Queue Failure',
  props<{error: IGlobalError}>(),
);


export const getDataTimeStamps = createAction(
  '[Core Shared][Time Stamps] Get Data Time Stamps',
);

export const getDataTimeStampsAsAdmin = createAction(
  '[Core Shared][Time Stamps] Get Data Time Stamp As Admin',
);

export const getDataTimeStampsSuccess = createAction(
  '[Core Shared][Time Stamps] Get Data Time Stamps Success',
  props<{store: IStore, dataTimeStamps: IDataTimeStamps}>(),
);

export const getDataTimeStampsAsAdminSuccess = createAction(
  '[Core Shared][Time Stamps] Get Data as Admin Time Stamps Success',
  props<{dataTimeStamps: Record<string, IDataTimeStamps>}>(),
);

export const getDataTimeStampsFailure = createAction(
  '[Core Shared][Time Stamps] Get Data Time Stamps Failure',
  props<{error: IGlobalError}>(),
);


